import { Box, Paper, Typography } from '@mui/material';
import {
  CaretRightIcon,
  CheckCircleIcon,
  CircleIcon,
  XCircleIcon,
} from '@phosphor-icons/react';
import { TermDto } from '@act/shared/data-transfer-objects';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface ConsentTermEntryProps {
  term: TermDto;
  linkKey: string;
}

const ConsentTermEntry = ({ term, linkKey }: ConsentTermEntryProps) => {
  const { t } = useTranslation();

  function getTermIcon() {
    if (term.consented === true) {
      return <CheckCircleIcon size={24} color="#26AB76" />;
    }
    if (term.consented === false) {
      return <XCircleIcon size={24} color="#CD0E04" />;
    }
    return <CircleIcon size={24} color="#000000" />;
  }
  return (
    <Link to={`/${term.key}?key=${linkKey}`} style={{ textDecoration: 'none' }}>
      <Box
        elevation={1}
        component={Paper}
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          gap: 1,
          width: '100%',
          padding: 2,
          borderRadius: 1.5,
          backgroundColor: '#ffffff',
          boxSizing: 'border-box',
        }}
      >
        {getTermIcon()}
        <Typography variant="bodyMedium">{t(term.name)}</Typography>
        <Box sx={{ marginLeft: 'auto' }}>
          <CaretRightIcon size={24} />
        </Box>
      </Box>
    </Link>
  );
};

export default ConsentTermEntry;
